import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  TablePagination,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import archivedTemplates from "../Data/process-and-templates/Archived_Processes_Templates/Templates/archivedTemplates.json";
import archivedProcesses from "../Data/process-and-templates/Archived_Processes_Templates/Processes/archivedProcesses.json";
import "./ArchivedAccordion.css"; 

const sortByVersion = (a, b) => {
  const parseVersion = (v) =>
    v.replace("V", "").split(".").map((n) => parseInt(n, 10));

  const [majorA, minorA] = parseVersion(a.version);
  const [majorB, minorB] = parseVersion(b.version);

  if (majorA !== majorB) return majorA - majorB;
  return minorA - minorB;
};

const ArchivedAccordion = () => {
  const sortedTemplates = [...archivedTemplates].sort(sortByVersion);
  const sortedProcesses = [...archivedProcesses].sort(sortByVersion);
  const [templatesPage, setTemplatesPage] = useState(0);
  const rowsPerPageTemplates = 5;
  const [processPage, setProcessPage] = useState(0);
  const rowsPerPageProcesses = 5;

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography className="accordion-title">
          Archived Processes & Templates
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {/* Templates Section */}
        <Typography variant="h6" gutterBottom className="table-title">
          Templates
        </Typography>
        <TableContainer component={Paper} className="table-container">
          <Table size="small">
            <TableHead>
              <TableRow className="table-header">
                <TableCell>SL No.</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Version</TableCell>
                <TableCell>Download</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedTemplates
                .slice(
                  templatesPage * rowsPerPageTemplates,
                  templatesPage * rowsPerPageTemplates + rowsPerPageTemplates
                )
                .map((item, index) => (
                  <TableRow key={item.id}>
                    <TableCell>
                      {templatesPage * rowsPerPageTemplates + index + 1}
                    </TableCell>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>{item.version}</TableCell>
                    <TableCell>
                      <a
                        href={require(`../Data/process-and-templates/${item.download}`)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="download-link"
                      >
                        Download
                      </a>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          <Box className="pagination-box">
            <TablePagination
              component="div"
              count={sortedTemplates.length}
              page={templatesPage}
              onPageChange={(e, newPage) => setTemplatesPage(newPage)}
              rowsPerPage={rowsPerPageTemplates}
              rowsPerPageOptions={[5]}
            />
          </Box>
        </TableContainer>

        {/* Processes Section */}
        <Typography variant="h6" gutterBottom className="table-title">
          Processes
        </Typography>
        <TableContainer component={Paper} className="table-container">
          <Table size="small">
            <TableHead>
              <TableRow className="table-header">
                <TableCell>SL No.</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Version</TableCell>
                <TableCell>Download</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedProcesses
                .slice(
                  processPage * rowsPerPageProcesses,
                  processPage * rowsPerPageProcesses + rowsPerPageProcesses
                )
                .map((item, index) => (
                  <TableRow key={item.id}>
                    <TableCell>
                      {processPage * rowsPerPageProcesses + index + 1}
                    </TableCell>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>{item.version}</TableCell>
                    <TableCell>
                      <a
                        href={process.env.PUBLIC_URL + `/images/${item.download}.pdf#toolbar=0`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="download-link"
                      >
                        Download
                      </a>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          <Box className="pagination-box">
            <TablePagination
              component="div"
              count={sortedProcesses.length}
              page={processPage}
              onPageChange={(e, newPage) => setProcessPage(newPage)}
              rowsPerPage={rowsPerPageProcesses}
              rowsPerPageOptions={[5]}
            />
          </Box>
        </TableContainer>
      </AccordionDetails>
    </Accordion>
  );
};

export default ArchivedAccordion;
